import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../../theme/theme.types";

export const BracketTypeSelector = styled.div<IStyledComponentProps>`
  &.bracket-type-selector {
    display: flex;
    margin-top: 12px;
    svg {
      margin-right: 10px;
      width: 65px;
      &:hover {
        circle {
          cursor: pointer;
          fill: ${(props) => props.theme.colors?.essential.buttonGreen};
        }
      }
    }
  }
`;

export default { BracketTypeSelector };
